import { styled } from "@mui/material";
import {
  Button,
  Drawer,
  Text,
} from "@totalenergiescode/mobility-business-rev-design-system";

import { RoundedTopLeftContainer } from "@/components/containers/RoundedTopLeftContainer";

export const StyledDrawer = styled(Drawer)`
  min-width: 520px;
  max-width: 100%;
`;

export const StyledHeaderText = styled(Text)`
  padding: 20px;
  max-width: 100%;
  white-space: pre-line;
  word-break: break-word;
  overflow-wrap: break-word;
`;

export const StyledDrawerInnerContainer = styled("div")``;

export const StyledSection = styled("div")``;

export const StyledAccountContainer = styled("div")`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
`;

export const StyledInputContainer = styled("div")`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  width: 100%;
  flex-wrap: wrap;
  padding-block: 15px;

  /* Le premier contrôle s'étire pour occuper l'espace disponible */
  & > :first-of-type {
    flex: 1 1 auto;
    min-width: 0;
  }

  &.account-row {
    flex-wrap: nowrap;
  }
`;

export const StyledSearchButton = styled(Button)`
  flex: 0 0 140px;
  width: 140px;
  max-width: 140px;
  padding-inline: 12px;
`;

export const StyledButtonContainer = styled("div")`
  padding-block: 15px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 40px;
  justify-content: space-between;
`;

export const StyledRoundedTopLeftContainer = styled(RoundedTopLeftContainer)`
  min-width: 520px;
`;

export const StyledSelectedAccountTextContainer = styled("div")`
  display: flex;
  flex-direction: row;
  align-items: center;

  & > :last-child {
    margin-left: 10px;
  }
`;

export const StyledGetTemplateButtonContainer = styled("div")`
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
  width: 100%;
`;
